export default __webpack_public_path__ + "static/media/art-pro-brw-banner-1.92e42ca0.jpg";